jQuery($ => {
    const allSwipers = $('.swiper-container');
    // homepage swiper start
    const eventSwiper = $("#eventsSwiper");
    if (eventSwiper.length > 0) {
        const swiper = new Swiper(eventSwiper, {
            slidesPerView: 1,
            spaceBetween: 15,
            pagination: {
                el: ".swiper-pagination",
                type: "bullets",
                clickable: true
            },
            effect: "fade",
            autoplay: {
                delay: 5000
            },
            breakpoints: {
                992: {
                },
            }
        });
    };

    const shortNewsSwiper = $("#shortNewsSwiper");
    if (shortNewsSwiper.length > 0) {
        const swiper = new Swiper(shortNewsSwiper, {
            slidesPerView: 1,
            freeMode: false,
            allowTouchMove: true,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            pagination: {
                el: ".swiper-pagination",
                type: "bullets",
                clickable: true
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                    autoHeight: false
                },
                992: {
                    slidesPerView: 2,
                    slidesPerColumn: 2,
                    spaceBetween: 30,
                    slidesPerColumnFill: "row",
                    allowTouchMove: false,
                    autoHeight: false,
                    threshold: 200,
                }
            }
        });
    };

    const calendarSwiper = $("#homeCalendarSwiper");
    if (calendarSwiper.length > 0) {
        const swiper = new Swiper(calendarSwiper, {
            slidesPerView: 1,
            spaceBetween: 30,
            freeMode: false,
            navigation: {
                nextEl: "#homeCalendarSwiper .e-calendar__arrow--next",
                prevEl: "#homeCalendarSwiper .e-calendar__arrow--prev",
                disabledClass: "disabled"
            },
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            breakpoints: {
                992: {
                    allowTouchMove: false
                }
            }
        });
    };

    const lastNewsSwiper = $("#lastNewsSwiper");
    if (lastNewsSwiper.length > 0) {
        const swiper = new Swiper(lastNewsSwiper, {
            slidesPerView: 1,
            spaceBetween: 30,
            allowTouchMove: true,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            runCallbacksOnInit: true,
            pagination: {
                el: ".swiper-pagination",
                type: "bullets",
                clickable: true
            },
            breakpoints: {
                576: {
                    slidesPerView: 2
                },
                768: {
                    slidesPerView: 2
                },
                992: {
                    slidesPerView: 3,
                },
                1260: {
                    slidesPerView: 4,
                    allowTouchMove: false
                }
            },
            on: {
                init: function() {
                    setTimeout(function() {
                        const newsBox = $('#lastNewsSwiper .e-news-box');
                        if (newsBox.length > 0) {
                            newsBox.each((index, news) => {
                                let title = $(news).find('.e-news-box__title');
                                const desc = $(news).find('.e-news-box__desc');

                                const wrapperHeight = $(news).find('.e-news-box__text').height();
                                let titleHeight = $(title).outerHeight(true);
                                const descHeight = $(desc).outerHeight();
                                const height = wrapperHeight - titleHeight;

                                if (titleHeight >= wrapperHeight) {
                                    const titles = new Dotdotdot($(title)[0], {
                                        ellipsis: " [...]",
                                        height: wrapperHeight,
                                        watch: true,
                                        truncate: "word"
                                    });
                                }

                                if (titleHeight < wrapperHeight) {
                                    const descriptions = new Dotdotdot($(desc)[0], {
                                        ellipsis: " [...]",
                                        height,
                                        watch: true,
                                        truncate: "word",
                                    });
                                }
                            });
                        }
                    }, 300);
                }
            }
        });
    };

    const statementSwiper = $("#statementSwiper");
    if (statementSwiper.length > 0) {
        const swiper = new Swiper(statementSwiper, {
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            slidesPerView: 1,
            spaceBetween: 30,
            allowTouchMove: true,
            pagination: {
                el: ".swiper-pagination",
                type: "bullets",
                clickable: true
            },
            navigation: {
                nextEl: ".m-statement__arrow--next",
                prevEl: ".m-statement__arrow--prev"
            },
            breakpoints: {
                576: {
                    slidesPerView: 2
                },
                768: {
                    slidesPerView: 2
                },
                992: {
                    slidesPerView: 3,
                },
                1260: {
                    slidesPerView: 4,
                    allowTouchMove: false,
                }
            }
        });
    };

    // subpages swiper start
    const gallerySwiper = $(".e-gallery--type1");
    if (gallerySwiper.length > 0) {
        const swiper = new Swiper(gallerySwiper, {
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            slidesPerView: 1,
            spaceBetween: 30,
            allowTouchMove: true,
            watchOverflow: true,
            pagination: {
                el: ".swiper-pagination",
                type: "bullets",
                clickable: true
            },
            navigation: {
                nextEl: ".e-nav-arrow--next",
                prevEl: ".e-nav-arrow--prev",
                disabledClass: "disabled"
            },
            breakpoints: {
                576: {
                    slidesPerView: 2
                },
                768: {
                    slidesPerView: 2
                },
                992: {
                    slidesPerView: 3,
                    allowTouchMove: false
                }
            }
        });
    };

    const gallerySecondSwiper = $(".e-gallery--type2");
    if (gallerySecondSwiper.length > 0) {
        const swiper = new Swiper(gallerySecondSwiper, {
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            slidesPerView: 1,
            spaceBetween: 30,
            allowTouchMove: true,
            watchOverflow: true,
            pagination: {
                el: ".swiper-pagination",
                type: "bullets",
                clickable: true
            },
            navigation: {
                nextEl: ".e-nav-arrow--next",
                prevEl: ".e-nav-arrow--prev",
                disabledClass: "disabled"
            },
            breakpoints: {
                576: {
                    slidesPerView: 2
                },
                768: {
                    slidesPerView: 2
                },
                992: {
                    slidesPerView: 4,
                    allowTouchMove: false
                }
            }
        });
    };

    const calendarPageSwiper = $("#calendarPageSwiper");
    if (calendarPageSwiper.length > 0) {
        const swiper = new Swiper(calendarPageSwiper, {
            slidesPerView: 1,
            spaceBetween: 30,
            freeMode: false,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            navigation: {
                nextEl: "#calendarPageSwiper .e-calendar__arrow--next",
                prevEl: "#calendarPageSwiper .e-calendar__arrow--prev",
                disabledClass: "disabled"
            },
            breakpoints: {
                992: {
                    allowTouchMove: false,
                    slidesPerView: 2,
                    spaceBetween: 30
                }
            }
        });
    };

    const subpageNavSwiper = $(".e-subpage-nav--mobile");
    if (subpageNavSwiper.length > 0) {
        const swiper = new Swiper(subpageNavSwiper, {
            slidesPerView: 'auto',
            spaceBetween: 10,
            freeMode: true,
        });
    };

});

document.body.onload = function() {
    var swipers = document.querySelectorAll('.swiper-container');
    swipers.forEach(swiper => swiper.classList.add('swiper-window-load'));
}
